// Define types for the feature comparison
interface ComparisonFeature {
  id: string;
  name: string;
  digitalValue: string | boolean;
  physicalValue: string | boolean;
  tooltip?: string; // Optional explanation for the feature
}

export enum ValueDisplayType {
  CHECKMARK = "CHECKMARK",
  TEXT = "TEXT",
  BOTH = "BOTH",
}

// Define how each feature should be displayed
interface FeatureDisplayConfig {
  id: string;
  displayType: ValueDisplayType;
}

// Static data for features
export const goldInvestmentFeatures: ComparisonFeature[] = [
  {
    id: "min-investment",
    name: "Minimum investment",
    digitalValue: "₹10",
    physicalValue: "Higher",
    tooltip: "Starting investment amount required"
  },
  {
    id: "buy-sell-247",
    name: "Buy or sell 24x7",
    digitalValue: true,
    physicalValue: false
  },
  {
    id: "making-charges",
    name: "No making charges",
    digitalValue: true,
    physicalValue: false
  },
  {
    id: "purity",
    name: "24K, 999.9+ purity, verified partners",
    digitalValue: true,
    physicalValue: "Varies"
  },
  {
    id: "redeem",
    name: "Redeem as physical gold",
    digitalValue: true,
    physicalValue: true
  }
];

export const silverInvestmentFeatures: ComparisonFeature[] = [
  {
    id: "min-investment",
    name: "Minimum investment",
    digitalValue: "₹10",
    physicalValue: "Higher",
    tooltip: "Starting investment amount required"
  },
  {
    id: "buy-sell-247",
    name: "Buy or sell 24x7",
    digitalValue: true,
    physicalValue: false
  },
  {
    id: "making-charges",
    name: "No making charges",
    digitalValue: true,
    physicalValue: false
  },
  {
    id: "purity",
    name: "999.9+ purity, verified partners",
    digitalValue: true,
    physicalValue: "Varies"
  },
  {
    id: "redeem",
    name: "Redeem as physical silver",
    digitalValue: true,
    physicalValue: true
  }
];

// Display configuration for each feature
export const featureDisplayConfig: FeatureDisplayConfig[] = [
  { id: "min-investment", displayType: ValueDisplayType.TEXT },
  { id: "buy-sell-247", displayType: ValueDisplayType.CHECKMARK },
  { id: "making-charges", displayType: ValueDisplayType.CHECKMARK },
  { id: "purity", displayType: ValueDisplayType.BOTH },
  { id: "redeem", displayType: ValueDisplayType.CHECKMARK }
];